import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

export function LockScreen({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:56px 14px 34px;display:flex;flex-direction:column;background:linear-gradient(180deg,rgba(10,12,18,.3) 0%,rgba(10,12,18,.6) 60%,rgba(10,12,18,.85) 100%),url(/assets/lock-vito.png) center/cover no-repeat")}>
      <div style={sx("text-align:center;padding:24px 0 32px;display:flex;flex-direction:column;gap:2px")}>
        <span style={sx("font-size:var(--fs-md);opacity:.8")}>
          Monday, 17 August
        </span>
        <span style={sx("font-size:72px;font-weight:var(--fw-bold);letter-spacing:var(--ls-2xs);line-height:80px")}>
          9:41
        </span>
      </div>
      <div style={sx("display:flex;flex-direction:column;gap:10px")}>
        {v.kMailPush ? (
          <PushCard
            onClick={v.kOpenMail}
            app="Mail"
            tint="#0a84ff"
            icon="email"
            body={`${v.managerEmailAddress} invited you to their NordVPN group.`}
          />
        ) : null}
        {v.kMessagePush ? (
          <PushCard
            onClick={v.kOpenMessages}
            app="Messages"
            tint="#32d74b"
            icon="message"
            body={`${v.managerEmailAddress}: Sorted you a seat on my NordVPN plan`}
          />
        ) : null}
        {v.kBreachPush ? (
          <Hov
            as="button"
            onClick={v.kTabMonitor}
            style={sx(
              "text-align:left;padding:14px 16px;border-radius:var(--radius-lg);" +
                "background:rgba(255,255,255,.1);backdrop-filter:blur(16px);" +
                "border:1px solid rgba(255,255,255,.12);color:#fff;font-family:inherit;" +
                "cursor:pointer;display:flex;gap:12px;animation:gpop 250ms var(--ease-out)"
            )}
            hoverStyle={sx("background:rgba(255,255,255,.16)")}
          >
            <span
              style={sx(
                "width:38px;height:38px;flex:none;border-radius:10px;" +
                  "background:var(--app-icon-surface);display:flex;align-items:center;" +
                  "justify-content:center;box-shadow:var(--shadow-app-icon-feature)"
              )}
            >
              <span
                style={sx(
                  "width:22px;height:22px;background:var(--color-red-600);" +
                    "-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;" +
                    "mask:url(/assets/icons/security-score.svg) center/contain no-repeat"
                )}
              />
            </span>
            <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
              <span style={sx("display:flex;justify-content:space-between;align-items:baseline")}>
                <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-bold)")}>
                  NordVPN
                </span>
                <span style={sx("font-size:var(--fs-2xs);opacity:.7")}>now</span>
              </span>
              <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
                Your credentials were found in a data breach. Open Monitor to see what leaked.
              </span>
            </span>
          </Hov>
        ) : null}
        {v.kDevicePush ? (
          <>
            <Hov as="button" onClick={v.openDeviceRequest} style={sx("text-align:left;padding:14px 16px;border-radius:var(--radius-lg);background:rgba(255,255,255,.1);backdrop-filter:blur(16px);border:1px solid rgba(255,255,255,.12);color:#fff;font-family:inherit;cursor:pointer;display:flex;gap:12px;animation:gpop 250ms var(--ease-out)")} hoverStyle={sx("background:rgba(255,255,255,.16)")}>
              <span style={sx("width:38px;height:38px;flex:none;border-radius:10px;background:var(--app-icon-surface);display:flex;align-items:center;justify-content:center;box-shadow:var(--shadow-app-icon-feature)")}>
                <span style={sx("width:22px;height:22px;background:var(--color-blue-600);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
                <span style={sx("display:flex;justify-content:space-between;align-items:baseline")}>
                  <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-bold)")}>
                    NordVPN
                  </span>
                  <span style={sx("font-size:var(--fs-2xs);opacity:.7")}>
                    now
                  </span>
                </span>
                <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
                  Michael asks this iPhone to share blocked threats. Your call.
                </span>
              </span>
            </Hov>
          </>
        ) : null}
        {v.kQuietLock ? (
          <>
            <div style={sx("text-align:center;font-size:var(--fs-xs);color:rgba(255,255,255,.5)")}>
              No notifications
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

/**
 * A lock-screen notification from a system app. The invite arrives through
 * Mail or Messages before any Nord software is involved, so these carry the
 * platform's app tile rather than NordVPN's.
 */
function PushCard({
  onClick,
  app,
  tint,
  icon,
  body,
}: {
  onClick: () => void
  app: string
  tint: string
  icon: string
  body: string
}) {
  return (
    <Hov
      as="button"
      onClick={onClick}
      style={sx(
        'text-align:left;padding:14px 16px;border-radius:var(--radius-lg);' +
          'background:rgba(255,255,255,.1);backdrop-filter:blur(16px);' +
          'border:1px solid rgba(255,255,255,.12);color:#fff;font-family:inherit;' +
          'cursor:pointer;display:flex;gap:12px;animation:gpop 250ms var(--ease-out)'
      )}
      hoverStyle={sx('background:rgba(255,255,255,.16)')}
    >
      <span
        style={sx(
          `width:38px;height:38px;flex:none;border-radius:10px;background:${tint};` +
            `display:flex;align-items:center;justify-content:center;` +
            `box-shadow:var(--shadow-app-icon-feature)`
        )}
      >
        <span
          style={sx(
            `width:21px;height:21px;background:#fff;` +
              `-webkit-mask:url(/assets/icons/${icon}.svg) center/contain no-repeat;` +
              `mask:url(/assets/icons/${icon}.svg) center/contain no-repeat`
          )}
        />
      </span>
      <span style={sx('flex:1;display:flex;flex-direction:column;gap:2px;min-width:0')}>
        <span style={sx('display:flex;justify-content:space-between;align-items:baseline;gap:8px')}>
          <span style={sx('font-size:var(--fs-sm);font-weight:var(--fw-bold)')}>{app}</span>
          <span style={sx('font-size:var(--fs-2xs);opacity:.7;flex:none')}>now</span>
        </span>
        <span style={sx('font-size:var(--fs-sm);line-height:20px')}>{body}</span>
      </span>
    </Hov>
  )
}
